<template>
  <div class="big health-card-set">
    <div class="page_title">养生卡设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 状态 -->
            <div class="item">
              <span style="margin: 0 10px">状态</span>
              <div class="item-content">
                <el-radio-group
                  v-model="searchForm.status"
                  style="padding-top: 6px"
                  @change="getList"
                >
                  <el-radio :label="-1">全部</el-radio>
                  <el-radio :label="0">未上架</el-radio>
                  <el-radio :label="1">已上架</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1588') : false
              "
              @click="addOrEditBtn(1)"
              >添加</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1838') : false
              "
              @click="toRefundRecord"
              >退款记录</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="healthCardSetData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'click_coupon_num'">
                  <el-link
                    type="primary"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1587')
                        : false
                    "
                    @click="lookCoupon(1, scope.row.id)"
                    >{{ scope.row[item.prop] }}</el-link
                  >
                </div>
                <div v-else-if="item.prop == 'shop_coupon_num'">
                  <el-link
                    type="primary"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1587')
                        : false
                    "
                    @click="lookCoupon(2, scope.row.id)"
                  >
                    {{ scope.row[item.prop] }}</el-link
                  >
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateTimeFormat }}
                </div>
                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="addOrEditBtn(2, scope.row.id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1590')
                      : false
                  "
                  >编辑</el-button
                >

                <el-button
                  type="text"
                  @click="toStatistics(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1451')
                      : false
                  "
                  >统计</el-button
                >

                <el-button
                  v-if="!scope.row.status"
                  type="text"
                  @click="updateStatus(1, scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1591')
                      : false
                  "
                  >上架</el-button
                >

                <el-button
                  v-else
                  type="text"
                  @click="updateStatus(2, scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1591')
                      : false
                  "
                  >下架</el-button
                >
                <el-button
                  type="text"
                  @click="copyHealthCard(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1591')
                      : false
                  "
                  >复制</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 查看优惠券 -->
    <el-dialog
      :title="couponDiaText"
      width="1000px"
      custom-class="dia-coupon"
      ref="diaTable"
      :visible.sync="couponDia"
      :before-close="() => (couponDia = false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="padding: 10px 20px">
        <div style="border: 1px solid #f5f5f5">
          <el-table
            v-loading="couponDiaTableLoading"
            :data="couponTableDiaData"
            tooltip-effect="dark"
            height="400px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in couponTableDiaHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'message'">
                  {{ scope.row.use_condition }}
                </div>

                <div v-else-if="item.prop == 'use_time'">
                  <div v-if="scope.row['time_limit'] == 2">
                    {{ scope.row["time_start"] | dateFormat }} -
                    {{ scope.row["time_end"] | dateFormat }}
                  </div>
                  <div v-else>领取后{{ scope.row["time_days"] }}有效</div>
                </div>

                <div v-else-if="item.prop == 'show_time'">
                  {{ scope.row["show_start_time"] | dateFormat }} -
                  {{ scope.row["show_end_time"] | dateFormat }}
                </div>
                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
export default {
  components: {},
  data() {
    return {
      searchForm: {
        status: -1,
      },
      tableHeader: [
        {
          label: "养生卡名称",
          prop: "card_title",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "营销标题",
          prop: "title",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "营销副标题",
          prop: "desc",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "原价",
          prop: "market_price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "售价",
          prop: "price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "有效期",
          prop: "saved_day",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "诊疗优惠券数",
          prop: "click_coupon_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "商城优惠券数",
          prop: "shop_coupon_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "权益商品",
          prop: "goods_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      healthCardSetData: [],
      couponDiaTableLoading: false,
      couponTableDiaData: [],
      couponTableDiaHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "使用条件",
          prop: "message",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "使用时间",
          prop: "use_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取时间",
          prop: "show_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponDia: false,
      couponDiaText: "",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "已上架";
        case 0:
          return "未上架";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.searchForm);
      this.tableLoading = true;
      marketing.getHealthCardConfig(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.healthCardSetData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    // 统计
    toStatistics(row) {
      let { id, card_title } = row;
      this.$router.push({
        path: "/home/marketing/healthCareCard",
        query: {
          id,
          card_title,
        },
      });
    },
    // 添加/编辑
    addOrEditBtn(type, id) {
      this.$router.push({
        path: "/home/marketing/healthCardSetDetail",
        query: {
          type,
          id,
        },
      });
    },
    // 上架/下架
    updateStatus(type, row) {
      let { id, status } = row;
      let text =
        type == 1 ? "确认上架当前养生卡吗？" : "确认下架当前养生卡吗？";
      let params = {
        id,
        status: !status ? 1 : 0,
      };
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          marketing.updateHealthCardConfigStatus(params).then((res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 查看优惠券
    lookCoupon(coupon_from, id) {
      this.couponDiaTableLoading = true;
      this.couponDia = true;
      this.couponDiaText = coupon_from == 1 ? "诊疗优惠劵" : "商城优惠券";
      marketing
        .getHealthCardConfigCoupon({ coupon_from, id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.couponTableDiaData = data;
          }
          this.couponDiaTableLoading = false;
        })
        .catch((err) => {
          this.couponDiaTableLoading = false;
        });
    },
    // 退款记录
    toRefundRecord() {
      this.$router.push({
        path: "/home/marketing/healthRefundRecord",
      });
    },
    // 复制养生卡
    copyHealthCard(row) {
      this.$router.push({
        path: "/home/marketing/healthCardSetDetail",
        query: {
          type: 1, // 新增模式
          copyId: row.id, // 要复制的养生卡ID
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.health-card-set {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>